import React, { useContext, useEffect, useCallback } from "react";
import {
  Route,
  Switch,
  Redirect,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import LayoutApp from "../../layout/app";
import Dashboard from "./dashboard";
import Design from "./design/";
import DocumentView from "./document";
import InformationView from "./infomation";
import { MainContext } from "../../context/main";
import { LinearProgress } from "@material-ui/core";
import { _checkAuth, _user } from "../../apis/auth";
import Profile from "./profile";
import User from "./user";

export default () => {
  const match = useRouteMatch();
  const history = useHistory();
  const mainContext = useContext(MainContext);
  const { userInfo, setuserInfo } = mainContext;

  const loadUserInfo = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (token) {
      const rsCheckAuth = await _checkAuth(token);
      if (rsCheckAuth && rsCheckAuth.token) {
        const rsUserInfo = await _user(rsCheckAuth.user_id, token);
        if (rsUserInfo && rsUserInfo.data) {
          setuserInfo({
            id: rsCheckAuth.user_id,
            email: rsUserInfo.data[0].email,
            first_name: rsUserInfo.data[0].first_name,
            last_name: rsUserInfo.data[0].last_name,
            profile_picture: rsUserInfo.data[0].profile_picture,
            role: rsCheckAuth.user_role,
            mea: rsUserInfo.data[0].mea,
            phone: rsUserInfo.data[0].phone,
            organization: rsUserInfo.data[0].organization,
            address: rsUserInfo.data[0].address,
            tambon: rsUserInfo.data[0].tambon,
            amphoe: rsUserInfo.data[0].amphoe,
            province: rsUserInfo.data[0].province,
            zipcode: rsUserInfo.data[0].zipcode,
            country: rsUserInfo.data[0].country,
            google: rsUserInfo.data[0].google,
          });
        } else {
          localStorage.clear();
          history.replace("/auth/signin");
        }
      } else {
        localStorage.clear();
        history.replace("/auth/signin");
      }
    } else {
      localStorage.clear();
      history.replace("/auth/signin");
    }
  }, [history, setuserInfo]);

  useEffect(() => {
    if (!userInfo) {
      loadUserInfo();
    }
    return () => {};
  }, [userInfo, loadUserInfo]);
  return (
    <LayoutApp>
      {userInfo ? (
        <Switch>
          <Redirect
            exact
            from={`${match.url}/`}
            to={`${match.url}/dashboard`}
          />
          <Route path={`${match.url}/dashboard`} component={Dashboard} />
          <Route path={`${match.url}/user`} component={User} />
          <Route path={`${match.url}/design`} component={Design} />
          <Route path={`${match.url}/profile`} component={Profile} />
          <Route path={`${match.url}/document`} component={DocumentView} />
          <Route
            path={`${match.url}/information`}
            component={InformationView}
          />
          <Redirect to="/404" />
        </Switch>
      ) : (
        <LinearProgress color="primary" />
      )}
    </LayoutApp>
  );
};
